import React, { PureComponent } from "react";

export default class ProjectContentTypeFormRecentActivity extends PureComponent {
  static displayName = "Project.Content.TypeForm.Types.RecentActivity";

  render() {
    return null;
  }
}
